import api from '../config/api';

// 上报前端侧的测试异常。失效链接的访问量就是靠这个统计出来的，
// 所以答题页和结果页两条路径都要上报，缺一条就会漏掉一批用户。
export const logErrorToServer = async (
  testId: string,
  errorType: string,
  errorMessage: string,
  additionalData?: Record<string, any>
) => {
  try {
    await api.post('/api/errors/log', {
      testId,
      sourceUrl: window.location.href,
      errorType,
      errorMessage,
      requestData: {
        currentUrl: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
        ...additionalData
      }
    });
    console.log('错误日志已记录:', errorType, errorMessage);
  } catch (logError) {
    console.error('记录错误日志失败:', logError);
  }
};
